import React from 'react'

function TabBody({name,activename,children}) {
  return (
   activename === name && children
  )
}

export default TabBody